import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const MobilityCard = ({ title, description, ...props }) => (
  <S.MobilityListCard shadow="0" bgColor="blue500" bdColor="blue300" {...props}>
    <S.MobilityListTitle>{title}</S.MobilityListTitle>
    <S.MobilityListDesc>{description}</S.MobilityListDesc>
  </S.MobilityListCard>
)

MobilityCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default MobilityCard
